import { Dialog, styled } from '@mui/material';

export const ModalUI = styled(Dialog)(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 16,
        padding: 24,
        [theme.breakpoints.down('sm')]: {
            padding: 16,
        },
        '& .MuiDialogTitle-root': {
            padding: 0,
            marginBottom: 16,
        },
        '& .MuiDialogContent-root': {
            padding: 0,
        },
        '& .MuiDialogActions-root': {
            padding: 0,
            marginTop: 16,
        },

        '& .footer-actions': {
            gap: 24,
        },
    },
}));
